import { ReactNode, ReactElement } from "react";
import { Children, cloneElement, isValidElement } from "react";

export const hasChildren = (
  element: ReactNode
): element is ReactElement<{ children: ReactNode | ReactNode[] }> =>
  isValidElement<{ children?: ReactNode[] }>(element) &&
  Boolean(element.props.children);

export const hasComplexChildren = (
  element: ReactNode
): element is ReactElement<{ children: ReactNode | ReactNode[] }> =>
  isValidElement(element) &&
  hasChildren(element) &&
  Children.toArray(element.props.children).reduce(
    (response: boolean, child: ReactNode): boolean =>
      response || isValidElement(child),
    false
  );

export const deepMap = (
  children: ReactNode | ReactNode[],
  deepMapFn: (
    child: ReactNode,
    index?: number,
    children?: ReactNode[]
  ) => ReactNode
): ReactNode[] =>
  Children.toArray(children).map(
    (child: ReactNode, index: number, mapChildren: ReactNode[]) => {
      if (isValidElement(child) && hasComplexChildren(child)) {
        return deepMapFn(
          cloneElement(child, {
            ...child.props,
            children: deepMap(child.props.children, deepMapFn),
          })
        );
      }
      return deepMapFn(child, index, mapChildren);
    }
  );
